import React from "react";
import AppRouter from "./AppRouter";
// import Header from "./components/Header";

function App() {
  return (
    <div>
      <AppRouter />
    </div>
  );
}

export default App;
